module.exports = __webpack_public_path__ + "static/img/diqiu.419cde44.png";